import {aboutMenuAdapter} from "../slices/aboutMenu";


export const {
    selectById: cartItemId,
    selectAll: selectAboutMenu,
} = aboutMenuAdapter.getSelectors((state)=> state.aboutMenu);